import { $color } from "@/utils/cssVarUtils"
import type { SystemStyleObject } from "@chakra-ui/theme-tools"


const baseStyle: SystemStyleObject = {
  bg: $color('bg-input-normal'),
  fontSize: 'xs',
  borderRadius: '0.5em',
  borderBottomWidth: '0.25em',
}

export const Kbd = {
  baseStyle,
}